import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  card: {
    width: '100%'
  }
}));
